import { render, staticRenderFns } from "./recommendHistory.vue?vue&type=template&id=5cbe40d3&scoped=true&"
import script from "./recommendHistory.vue?vue&type=script&lang=js&"
export * from "./recommendHistory.vue?vue&type=script&lang=js&"
import style0 from "./recommendHistory.vue?vue&type=style&index=0&id=5cbe40d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbe40d3",
  null
  
)

export default component.exports